import {useQuery} from "@tanstack/react-query";
import {listCustomerOfferBindingDefinitionsQueryOptions} from "./list-customer-offer-binding-definitions.query-options";

export function useListCustomerOfferBindingDefinitions() {
  return useQuery(listCustomerOfferBindingDefinitionsQueryOptions());
}
